import { DrugDosage } from './drug-dosage.interface';

export interface DrugItem {
    DrugID: number;
    DrugName: string;
    DrugType: string;
    DrugTypeID: number;
    ChemicalName: string;
    GenericDrugID: number;
    GenericDrugName: string;
    DrugTypeNDA: string;
    Dosages: DrugDosage[];
    GenericDosages?: DrugDosage[];
}

export class DrugItemConstructor implements DrugItem {
  DrugID: number;
  DrugName: string;
  DrugType: string;
  DrugTypeID: number;
  ChemicalName: string;
  GenericDrugID: number;
  GenericDrugName: string;
  DrugTypeNDA: string;
  Dosages: DrugDosage[];

  constructor(
    DrugID: number = null,
    DrugName: string = null,
    DrugType: string = null,
    DrugTypeID: number = null,
    ChemicalName: string = null,
    GenericDrugID: number = null,
    GenericDrugName: string = null,
    DrugTypeNDA: string = null,
    Dosages: DrugDosage[] = null,
  ) {
    this.DrugID = DrugID;
    this.DrugName = DrugName;
    this.DrugType = DrugType;
    this.DrugTypeID = DrugTypeID;
    this.ChemicalName = ChemicalName;
    this.GenericDrugID = GenericDrugID;
    this.GenericDrugName = GenericDrugName;
    this.DrugTypeNDA = DrugTypeNDA;
    this.Dosages = Dosages;
  }
}
